import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray, isVNode } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Mixin from './mixin';

function isMetaVnode(vnode) {
  if (!isVNode(vnode)) {
    return false;
  }

  var cp = vnode.componentOptions;
  return !!(cp && cp.Ctor && cp.Ctor.options && cp.Ctor.options.isListItemMeta);
}

export default {
  name: buildComponentName('ListItem'),
  mixins: [Mixin],
  inheritAttrs: false,
  props: {
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    extra: {
      type: String,
      default: ''
    }
  },
  computed: {
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-item");
    }
  },
  methods: {
    getVNodes: function getVNodes() {
      var slotDefault = this.$slots.default;
      var vnodes = {
        metas: [],
        others: []
      };

      if (isArray(slotDefault)) {
        vnodes = slotDefault.reduce(function (r, vnode) {
          if (isMetaVnode(vnode)) {
            r.metas.push(vnode);
          } else {
            r.others.push(vnode);
          }

          return r;
        }, vnodes);
      }

      return vnodes;
    },
    renderExtra: function renderExtra(children) {
      var h = this.$createElement;
      var slotExtra = this.$slots.extra,
          prefixCls = this.prefixCls,
          extra = this.extra;
      var nExtra = slotExtra || extra;

      if (!nExtra) {
        return children;
      }

      return h("div", {
        "class": "".concat(prefixCls, "-extra-wrap")
      }, [h("div", {
        "class": "".concat(prefixCls, "-main")
      }, [children]), h("div", {
        "class": "".concat(prefixCls, "-extra")
      }, [nExtra])]);
    },
    renderActions: function renderActions() {
      var h = this.$createElement;
      var slotActions = this.$slots.actions,
          prefixCls = this.prefixCls,
          actions = this.actions;
      var nActions = slotActions || actions;
      var actionsElement = null;

      if (isArray(nActions)) {
        var len = nActions.length;

        if (len > 0) {
          actionsElement = h("ul", {
            "class": "".concat(prefixCls, "-action")
          }, [nActions.map(function (v, i) {
            return h("li", [v, i !== len - 1 ? h("em", {
              "class": "".concat(prefixCls, "-action-split")
            }) : null]);
          })]);
        }
      }

      return actionsElement;
    },
    renderChildren: function renderChildren() {
      var _otherCls;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          getVNodes = this.getVNodes,
          renderActions = this.renderActions,
          renderExtra = this.renderExtra;
      var children = null;

      var _getVNodes = getVNodes(),
          metas = _getVNodes.metas,
          others = _getVNodes.others;

      var otherCls = (_otherCls = {}, _defineProperty(_otherCls, "".concat(prefixCls, "-content"), true), _defineProperty(_otherCls, "".concat(prefixCls, "-content-single"), metas.length === 0), _otherCls);
      var otherElement = others.length > 0 ? h("div", {
        "class": otherCls
      }, [others]) : null;
      children = [metas, otherElement, renderActions()];
      children = renderExtra(children);
      return children;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $attrs = this.$attrs,
        prefixCls = this.prefixCls,
        renderChildren = this.renderChildren;
    return h("div", _mergeJSXProps([{}, {
      class: [prefixCls],
      attrs: $attrs
    }]), [renderChildren()]);
  }
};